import Vue from 'vue'
import input from '@/components/controls/x-input'
import textarea from '@/components/controls/x-textarea'
import checkbox from '@/components/controls/x-checkbox'
import button from '@/components/controls/x-button'
import form from '@/components/controls/x-form'
import formSubmit from '@/components/controls/x-form-submit'
import select from '@/components/controls/x-select'
import spinner from '@/components/controls/x-spinner'
import radioGroup from '@/components/controls/x-radio-group'
import radioButton from '@/components/controls/x-radio-button'
import tooltip from '@/components/controls/x-tooltip'
import slider from '@/components/controls/x-slider'
import dateRangePicker from '@/components/controls/x-date-range-picker'

Vue.component('x-input', input)
Vue.component('x-textarea', textarea)
Vue.component('x-button', button)
Vue.component('x-form', form)
Vue.component('x-form-submit', formSubmit)
Vue.component('x-select', select)
Vue.component('x-radio-group', radioGroup)
Vue.component('x-radio-button', radioButton)
Vue.component('x-spinner', spinner)
Vue.component('x-checkbox', checkbox)
Vue.component('x-tooltip', tooltip)
Vue.component('x-slider', slider)
Vue.component('x-date-range-picker', dateRangePicker)
